"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
const styles = new Proxy({"Founders":"Founders-38f72","Title":"Title-38f72","Grid":"Grid-38f72","Card":"Card-38f72","CarouselWrap":"CarouselWrap-38f72","SlideOuter":"SlideOuter-38f72","Controls":"Controls-38f72","Dots":"Dots-38f72","Dot":"Dot-38f72","DotActive":"DotActive-38f72","ArrowBtn":"ArrowBtn-38f72","ImageWrap":"ImageWrap-38f72","CardFooter":"CardFooter-38f72","Info":"Info-38f72","Name":"Name-38f72","Position":"Position-38f72","Links":"Links-38f72"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./FoundersSlider.scss";*/
import { ResolvedFounder } from "./types";

function LinkedInIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="6" fill="#0A66C2" />
      <path
        d="M9.5 11.5H7V21H9.5V11.5ZM8.25 10.5C9.08 10.5 9.75 9.83 9.75 9C9.75 8.17 9.08 7.5 8.25 7.5C7.42 7.5 6.75 8.17 6.75 9C6.75 9.83 7.42 10.5 8.25 10.5ZM21 21H18.5V16.25C18.5 14.84 18.47 13 16.5 13C14.5 13 14.2 14.57 14.2 16.14V21H11.7V11.5H14.1V12.7H14.13C14.48 12.05 15.3 11.35 16.54 11.35C19.07 11.35 21 12.97 21 16.11V21Z"
        fill="white"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="6" fill="#3BB1E6" />
      <path
        d="M7 9.5C7 8.67 7.67 8 8.5 8H19.5C20.33 8 21 8.67 21 9.5V18.5C21 19.33 20.33 20 19.5 20H8.5C7.67 20 7 19.33 7 18.5V9.5ZM9 10L14 14L19 10H9ZM9 11.5V18H19V11.5L14 15.5L9 11.5Z"
        fill="white"
      />
    </svg>
  );
}

export default function FoundersCarousel({
  founders,
}: {
  founders: ResolvedFounder[];
}) {
  const sliderRef = useRef<Slider>(null);
  const [active, setActive] = useState(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const check = () => setActive(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!active) return null;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider ref={sliderRef} {...SETTINGS} className="FoundersSlider">
        {founders.map((founder, i) => (
          <div key={i} className={styles.SlideOuter}>
            <div className={styles.Card}>
              <div className={styles.ImageWrap}>
                <Image
                  src={founder.image.url || ""}
                  alt={founder.name}
                  width={400}
                  height={400}
                  className={styles.FounderImage}
                />
              </div>
              <div className={styles.CardFooter}>
                <div className={styles.Info}>
                  <span className={styles.Name}>{founder.name}</span>
                  <span className={styles.Position}>{founder.position}</span>
                </div>
                <div className={styles.Links}>
                  {founder.linkedin && (
                    <a
                      href={founder.linkedin}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="LinkedIn"
                    >
                      <LinkedInIcon />
                    </a>
                  )}
                  {founder.email && (
                    <a href={`mailto:${founder.email}`} aria-label="Email">
                      <MailIcon />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.Controls}>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <Image src={arrowLeft} alt="Previous" width={20} height={29} />
        </button>
        <ul className={styles.Dots}>
          {founders.map((_, i) => (
            <li
              key={i}
              className={
                i === current % founders.length ? styles.DotActive : styles.Dot
              }
              onClick={() => sliderRef.current?.slickGoTo(i)}
            />
          ))}
        </ul>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <Image src={arrowRight} alt="Next" width={20} height={29} />
        </button>
      </div>
    </div>
  );
}
